// /accounts → the v3 Other Accounts screen (the manually-fed portfolio,
// third stop of the My Stocks cluster). Thin shim like the other v2/pages.
import { Accounts } from '@/v2/v3/Accounts'

export function V2AccountsPage() {
  return <Accounts />
}
